<template>
  <v-app>
    <v-content>
      <v-container fluid ma-0 pa-0 v-resize="onResize">
        <v-img src="../../static/img/background_small.jpg" :width="x" :height="y" class="bgimage">
          <nav class="navbar navbar-light" style="height: 10px;">
            <a class="navbar-brand" href="#">
              <img src="../assets/img/logo.png" width="60" height="40" class="d-inline-block align-top" alt="">
              <div style="display: inline-block; padding-left: 5px; color: white;font-weight: 700;">
                <span> KENYA COFFEE </span>
              </div>
            </a>
            <div id="navbarNav" style="margin-right: 200px;">
              <ul class="nav justify-content-end">
                <li class="nav-item">
                  <a class="nav-link links" href="/">Home</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link links" href="https://onlinebanking.co-opbank.co.ke/" target="_blank">Co-op Online</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link links" href="https://www.nairobicoffeeexchange.co.ke/" target="_blank">NCE</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link links" href="https://www.agricultureauthority.go.ke/" target="_blank">AFA</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link links" href="https://www.cma.or.ke/" target="_blank">CMA</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link links active" href="/contactus">Contact Us</a>
                </li>
              </ul>
            </div>
          </nav>
          <v-layout align-center row  fill-height wrap>
            <v-flex xs4 offset-xs5 >

              <v-card elevation-12>
                <v-card-title>
                  <h3 class="headline mb-2 primary--text" color="secondary">Complete Password Configuration</h3>
                </v-card-title>
                <v-card-text>
                  <v-alert v-if="!tokenValid" :value="true" color="error"> {{ tokenInvalidMessage }} </v-alert>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-flex xs12>
                      <v-text-field
                        name="email"
                        label="Username"
                        v-model="user.email"
                        readonly
                        required>
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        name="password"
                        label="Password"
                        v-model="user.password"
                        :type="'password'"
                        :rules="passwordRules"
                        required>
                      </v-text-field>
                      <v-list v-if="passwordValidationError">
                        <template v-for="(item, index) in passwordErrors">
                          <v-list-item color="error" :key="index">
                            <v-list-item-content>
                              {{ item }}
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-list>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        name="confirmPassword"
                        label="Confirm Password"
                        v-model="user.confirmPassword"
                        :type="'password'"
                        :rules="confirmPasswordRules"
                        required>
                      </v-text-field>
                    </v-flex>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <div class="logindiv">
                    <a mt-5 class="pageLink black--text" href="/login"> Back to login?  </a>
                    <v-btn  class="btn loginbtn primary--text" @click="confirmUser" color="secondary">Submit</v-btn>
                  </div>
                </v-card-actions>
              </v-card>

            </v-flex>
          </v-layout>
        </v-img>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import config from '../config'
import axios from 'axios'

export default {
  name: 'completereg',
  data: function () {
    // console.log('Email', this.$route.params)
    return {
      year: new Date().getFullYear(),
      message: '',
      confirmToken: '',
      response: '',
      tokenValid: true,
      tokenInvalidMessage: '',
      user: {
        email: this.$route.params.email || '', // Initialize userEmail with route parameter or an empty string
        // email: this.$route.params || '',
        password: '',
        confirmPassword: ''
      },
      valid: false,
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length > 7) || 'Password length should be atleast 8 characters'
      ],
      confirmPasswordRules: [
        v => !!v || 'Confirm Password Field is required',
        v => (v && v === this.user.password) || 'Confirm Password must match password field'
      ],
      passwordValidationError: false,
      passwordErrors: []
    }
  },
  mounted () {
    this.user.email = this.$route.params.email || ''
    // this.user.email = {{ $route.params.email }}
    // var urlString = window.location.href
    // var url = new URL(urlString)
    // var t = url.searchParams.get('token')
    // this.confirmToken = t
    // console.log(t)
    // this.getTokenDetails()
  },
  methods: {
    // getTokenDetails () {
    //   const url = config.serverURI + '/confirm/user?token=' + this.confirmToken
    //   axios
    //     .get(url)
    //     .then(response => {
    //       var data = response.data
    //       if (data.error === true) {
    //         this.tokenValid = false
    //         this.tokenInvalidMessage = data.message
    //       } else {
    //         this.user.email = data.message
    //       }
    //     })
    //     .catch(error => {
    //       console.log(error)
    //       this.tokenInvalidMessage = 'Server appears to be offline'
    //     })
    // },
    confirmUser () {
      this.message = ''
      this.error = ''
      this.passwordErrors = []
      if (this.$refs.form.validate()) {
        var url = config.serverURI + '/confirm/completereg'
        axios.post(url, this.user)
          .then(response => {
            console.log('Response>>>', response)
            if (response.data.valid === false) {
              this.passwordErrors = response.data.passwordErrors
              this.passwordValidationError = true
              return
            }
            if (response.data.error === true) {
              this.tokenValid = false
              this.tokenInvalidMessage = response.data.message
              return
            }
            if (response.data.error !== false) {
              this.tokenInvalid = true
              this.tokenInvalidMessage = response.data.message
              return
            } else {
              window.location = '/login?message=' + response.data.message
            }

            this.resetUserObject()
            this.$refs.form.reset()
            this.message = response.data.message
          })
          .catch(error => {
            console.log('error', error.response)
          })
      }
    }
  }
}
</script>

<style scoped>
.labelstyle >>> .v-text-field__slot label {
  color: white;
  font-weight: 300px !important;
  font-family: 'Open Sans', sans-serif;
}

.inputstyle >>> .v-text-field__slot input {
  color: white;
  font-family: 'Open Sans', sans-serif;
  font-size: 20px;
}

.loginresponse {
  color: red;
  font-weight: 600;
}

.loginbtn {
  font-weight: bold;
  text-transform: capitalize;
  border-radius: 5px 5px 5px 5px;
  float: right;
  background-color: #B2CCC4 !important;
  width: 100px;
  border-color: #FFF;
  color:;
}

.loginfront {
  background: #000000B2 0% 0% no-repeat padding-box;
  padding-left: 40px;
}
.logindiv {
  margin: 0;
  width: 80%;
  margin-bottom: 20px;
  height: 50px;
  text-align: justify;
}
.pageLink {
  font-size: 14px;
  padding-top:10px;
  font-style: "Brandon Grotesque";
}
.loginhead {
  font-size: 14px;
  font-weight: 700;
  font-style: "Brandon Grotesque";
  margin-top:30px;
  margin-bottom:20px;
}
.links {
  padding-left: 30px;
  padding-right: 30px;
  color: white;
  font-size: 14px;
  font-weight: 600;
  font-style:"Brandon Grotesque";
}
.active {
  width: 150px;
  background-color: #7BC243;
  text-align: center;
  border-radius: 5px 5px 5px 5px;
}
</style>
